import type { HTMLAttributes, PropsWithChildren } from "react";

import { cn } from "../../lib/cn";

export function Card({ children, className, ...rest }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={cn(
        "rounded-[28px] border border-white/8 bg-surface-panel/90 p-5 shadow-panel backdrop-blur-sm",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
